import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import sv from './locales/sv.json';
import en from './locales/en.json';
import no from './locales/no.json';
import da from './locales/da.json';
import fi from './locales/fi.json';
import de from './locales/de.json';
import es from './locales/es.json';
import ru from './locales/ru.json';

/**
 * i18n-uppsättning för stats-sidan.
 *
 * Språket är ett PERSONLIGT val per användare: väljaren i headern sparar i
 * localStorage (nyckel `site_language`), detektorn faller annars tillbaka på
 * webbläsarspråket. Svenska är källspråk och fallback — onycklad/ny text
 * visas på svenska tills den extraherats (se docs/I18N-PROGRESS.md).
 *
 * Norska: webbläsare rapporterar nb/nn — båda mappas till vårt 'no'.
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'sv', label: 'Svenska', flag: '🇸🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'no', label: 'Norsk', flag: '🇳🇴' },
  { code: 'da', label: 'Dansk', flag: '🇩🇰' },
  { code: 'fi', label: 'Suomi', flag: '🇫🇮' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      en: { translation: en },
      no: { translation: no },
      da: { translation: da },
      fi: { translation: fi },
      de: { translation: de },
      es: { translation: es },
      ru: { translation: ru },
    },
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    fallbackLng: {
      nb: ['no', 'sv'],
      nn: ['no', 'sv'],
      default: ['sv'],
    },
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'site_language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React XSS-skyddar redan
    },
    returnEmptyString: false,
  });

/**
 * Aktivt locale för datum-/talformatering (t.ex. toLocaleTimeString).
 *
 * @returns {string} BCP 47-tagg för aktivt språk (t.ex. "sv-SE").
 */
export const currentLocale = () => {
  const map = {
    sv: 'sv-SE', en: 'en-GB', no: 'nb-NO', da: 'da-DK',
    fi: 'fi-FI', de: 'de-DE', es: 'es-ES', ru: 'ru-RU',
  };
  return map[i18n.resolvedLanguage] || 'sv-SE';
};

export default i18n;
